import { render, staticRenderFns } from "./AuthorBreadcrumbs.vue?vue&type=template&id=10e40e03"
import script from "./AuthorBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AuthorBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports